import Checkbox from '@mui/material/Checkbox';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import {TreeItem as MUITreeItem, TreeView} from '@mui/x-tree-view';
import {bool, func, object, objectOf} from 'prop-types';
import {connect} from 'react-redux';

import FormControlLabel from '@explorer/components/ui/filter-form-control-label';
import {ITEM_TYPES, SENSOR_GROUPS} from '@explorer/constants/item-types';
import {getAvailableItemTypes} from '@explorer/selectors/item-types';

const TreeItem = props => (
  <MUITreeItem
    sx={{
      '& .MuiTreeItem-content': {
        padding: 0,
        '&:hover, &.Mui-selected, &.Mui-focused, &.Mui-selected:hover, &.Mui-focused:hover, &.Mui-selected.Mui-focused':
          {
            backgroundColor: 'transparent',
          },
      },
    }}
    {...props}
  />
);

const SourcesPicker = props => {
  const onGroupSelect = groupTypes => event => {
    const itemsMap = {};
    groupTypes.forEach(type => (itemsMap[type] = event.target.checked));
    props.onChange(itemsMap);
  };

  const sensorGroupKeys = Object.keys(SENSOR_GROUPS);
  const defaultExpanded = [...sensorGroupKeys, ITEM_TYPES.PSSCENE];

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultExpanded={defaultExpanded}
    >
      {sensorGroupKeys.map(group => {
        const groupTypes = SENSOR_GROUPS[group].types.filter(t =>
          props.itemTypes.types.includes(t)
        );

        const allSelected = groupTypes.every(type => props.selected[type]);
        const someSelected = groupTypes.some(type => props.selected[type]);

        return (
          <TreeItem
            key={group}
            nodeId={group}
            label={
              <FormControlLabel
                disabled={props.disabled}
                control={
                  <Checkbox
                    color="primary"
                    name={group}
                    checked={allSelected}
                    indeterminate={someSelected && !allSelected}
                    onChange={onGroupSelect(groupTypes)}
                  />
                }
                label={<b>{SENSOR_GROUPS[group].label}</b>}
              />
            }
          >
            {groupTypes.map(type => (
              <TreeItem
                key={type}
                nodeId={type}
                label={
                  <FormControlLabel
                    disabled={props.disabled}
                    control={<Checkbox color="primary" name={type} />}
                    checked={!!props.selected[type]}
                    label={props.itemTypes.typesMap[type].display_name}
                    onChange={({target}) =>
                      props.onChange({[target.name]: target.checked})
                    }
                    data-qe={`${type}-filter-checkbox`}
                  />
                }
              />
            ))}
          </TreeItem>
        );
      })}
    </TreeView>
  );
};

SourcesPicker.propTypes = {
  selected: objectOf(bool).isRequired,
  itemTypes: object.isRequired,
  onChange: func.isRequired,
  disabled: bool,
};

const mapStateToProps = state => ({
  itemTypes: getAvailableItemTypes(state),
});

export default connect(mapStateToProps)(SourcesPicker);
